import { render, staticRenderFns } from "./ReservationsBookSpace.vue?vue&type=template&id=6d64628c"
import script from "./ReservationsBookSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsBookSpace.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports